import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import {
  adminDeleteGlobalMessage,
  adminSetGlobalMessage,
  getAdminGlobalMessage,
} from '@api/adminGlobalMessages';
import { IAdminGlobalMessage } from '@interfaces/adminGlobalMessages';

export const handleGetAdminGlobalMessage = createAsyncThunk<
  AxiosResponse<IAdminGlobalMessage>,
  void
>('getAdminGlobalMessage', getAdminGlobalMessage);

export const handleAdminSetGlobalMessage = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminGlobalMessage
>('adminSetGlobalMessage', adminSetGlobalMessage);

export const handleAdminDeleteGlobalMessage = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  number
>('adminDeleteGlobalMessage', adminDeleteGlobalMessage);
